import { render, staticRenderFns } from "./CharacterList.vue?vue&type=template&id=6cb5f4e5&scoped=true&"
import script from "./CharacterList.vue?vue&type=script&lang=js&"
export * from "./CharacterList.vue?vue&type=script&lang=js&"
import style0 from "./CharacterList.vue?vue&type=style&index=0&id=6cb5f4e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb5f4e5",
  null
  
)

export default component.exports